/**
 * Frontend configuration for different environments
 */

interface Config {
  apiBaseUrl: string;
  apiTimeout: number;
  environment: string;
}

const developmentConfig: Config = {
  apiBaseUrl: `${process.env.REACT_APP_API_BASE_URL}`,
  apiTimeout: 10000, // 10 seconds
  environment: 'development'
};

const productionConfig: Config = {
  // In production, we'll use the environment variable or default to relative path
  // This assumes frontend and backend are deployed to the same domain
  apiBaseUrl: `${process.env.REACT_APP_API_BASE_URL}`,
  apiTimeout: 30000, // 30 seconds for production
  environment: 'production'
};

// Determine which configuration to use based on the environment
const isProduction = process.env.NODE_ENV === 'production';
const config: Config = isProduction ? productionConfig : developmentConfig;

export default config;
